import { get } from "lodash";
import { ChallengeStatistics } from "./JamCommon";
import { JamEventLogEntry } from "./JamEventLogEntry";
import { JamLeaderboardEntry } from "./JamLeaderboardEntry";

export interface EventDashboardResponse {
    leaderBoardEntryHistory: JamLeaderboardEntry[];
    challengeStatistics: ChallengeStatistics[];
    eventLogs: JamEventLogEntry[];
}

export const objectToEventDashboardResponse = (o: object) => {
  const leaderBoardEntryHistory = get(o, "leaderBoardEntry", get(o, "leaderBoardEntryHistory", [])).map(JamLeaderboardEntry.fromPlainObject);
   const challengeStatistics = get(o , "challengeStatistics", []).map(
    ChallengeStatistics.fromPlainObject
  );
  const eventLogs = get(o, "eventLogs", []).map(
    JamEventLogEntry.fromPlainObject
  );
  return {
    leaderBoardEntryHistory,
    challengeStatistics,
    eventLogs
  };
};